import React, { useState, useEffect, useRef } from "react";
import "../Service/Service.css"
const Service = ({ serv_name, desc, clas }) => {
     const [isActive, setIsActive] = useState(false);
     const servicesRef = useRef(null);

     useEffect(() => {
       const options = {
         root: null,
         rootMargin: "0px",
         threshold: 0.2, // Adjust this threshold as needed
       };

       const handleIntersect = (entries, observer) => {
         entries.forEach((entry) => {
           if (entry.isIntersecting) {
             setIsActive(true);
           } else {
             setIsActive(false);
           }
         });
       };

       const observer = new IntersectionObserver(handleIntersect, options);
       observer.observe(servicesRef.current);

       // Cleanup observer on component unmount
       return () => {
         observer.disconnect();
       };
     }, []);
    return (
      <>
        <div
          className={`serviceBlocks ${isActive ? "ser-active" : ""}`}
          ref={servicesRef}
        >
          <a href="/">
            <i className={clas}></i>
          </a>
          <h1>{serv_name}</h1> <br />
          <span>{desc}</span>
        </div>
      </>
    );
}

export default Service